import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Renders message body. Plain-text for user turns (we should never
 * trust user-supplied markdown - they could embed link bait); full
 * markdown for assistant turns.
 *
 * `remark-gfm` adds tables, strikethrough, autolinks, task lists -
 * matching what showdown produced in the legacy dashboard. Code
 * blocks render with default styling for now; D5 may add syntax
 * highlighting if needed.
 *
 * react-markdown sanitises by default - assistant content can't
 * inject scripts even if the model is coerced into producing
 * `<script>` tags. Cheap defence-in-depth on top of our prompt
 * filtering.
 */
interface MessageContentProps {
  content: string;
  isUser: boolean;
}

export function MessageContent({ content, isUser }: MessageContentProps) {
  if (isUser) {
    // Preserve newlines without trusting markdown - `whitespace:
    // pre-wrap` in CSS handles the line breaks.
    return <p className="message-content message-content-user">{content}</p>;
  }

  return (
    <div className="message-content message-content-assistant">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // External links open in a new tab. rel for security
          // (no opener access to our window).
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
